(() => {
  'use strict';
  if (Number(window.Shopify?.theme?.id) !== 186497171834) return;
  const styledIcons = new WeakSet();
  let queued = false;

  function syncProductPrice(info, form) {
    const source = info?.querySelector(':scope > [id^="price-"]');
    const price = source?.querySelector('.price');
    const onSale = price?.classList.contains('price--on-sale');
    const value = price?.querySelector(onSale ? '.price__sale .price-item--sale' : '.price__regular .price-item--regular')?.textContent.trim();
    if (!value) return;
    let header = form.querySelector(':scope > .amr-cod-product-price');
    if (!header) {
      header = document.createElement('div');
      header.className = 'amr-cod-product-price';
      // The original Shopify status region remains available to screen readers.
      header.setAttribute('aria-hidden', 'true');
      const product = document.createElement('div');
      product.className = 'amr-cod-header-product';
      const priceLabel = document.createElement('span');
      priceLabel.className = 'amr-cod-header-label';
      priceLabel.textContent = 'Prix';
      const amount = document.createElement('span');
      amount.className = 'amr-cod-header-amount';
      product.append(priceLabel, amount, document.createElement('s'));
      const delivery = document.createElement('div');
      delivery.className = 'amr-cod-header-delivery';
      const deliveryLabel = document.createElement('span');
      deliveryLabel.className = 'amr-cod-header-label';
      deliveryLabel.textContent = 'Livraison';
      const deliveryAmount = document.createElement('span');
      deliveryAmount.className = 'amr-cod-header-shipping';
      delivery.append(deliveryLabel, deliveryAmount);
      header.append(product, delivery);
      form.prepend(header);
    }
    const previous = onSale ? price.querySelector('.price__sale s')?.textContent.trim() || '' : '';
    const compare = header.querySelector('s');
    if (compare.textContent !== previous) compare.textContent = previous;
    compare.hidden = !previous;
    const amount = header.querySelector('.amr-cod-header-amount');
    if (amount.textContent !== value) amount.textContent = value;
    // Mirror Releasit's calculated delivery; leave its totals and order data untouched.
    const shipping = form.querySelector('[data-checkout-line="shipping"] ._rsi-modal-checkout-line-value')?.textContent.trim();
    const shippingAmount = header.querySelector('.amr-cod-header-shipping');
    const shippingText = shipping || '\u2014';
    if (shippingAmount.textContent !== shippingText) shippingAmount.textContent = shippingText;
    form.classList.toggle('amr-cod-single-summary', Boolean(shipping));
    form.classList.add('amr-cod-has-product-price');
    source.classList.add('amr-cod-price-source');
  }

  function styleIcon(input) {
    if (styledIcons.has(input)) return;
    const background = getComputedStyle(input).backgroundImage;
    if (!background.startsWith('url(')) return;
    const data = background.slice(4, -1).replace(/^["']|["']$/g, '');
    if (!data.startsWith('data:image/svg+xml')) return;
    try {
      const svg = new DOMParser().parseFromString(decodeURIComponent(data.slice(data.indexOf(',') + 1)), 'image/svg+xml');
      if (svg.querySelector('parsererror')) return;
      svg.querySelectorAll('rect').forEach(rect => rect.remove());
      const color = input.name === 'first_name' ? '#503577' : '#d33782';
      svg.querySelectorAll('[fill]').forEach(node => node.setAttribute('fill', color));
      input.style.setProperty('background-image', 'url("data:image/svg+xml,' + encodeURIComponent(new XMLSerializer().serializeToString(svg)) + '")', 'important');
      styledIcons.add(input);
    } catch (_) { /* Keep the app's original icon if its format changes. */ }
  }

  function positionSubmitTotal(form, submit) {
    // Releasit updates this class globally. Move its existing price node, not a copied amount.
    const total = submit.querySelector('.rsi-cod-form-submit-total-value');
    let row = form.querySelector('.amr-cod-submit-total');
    if (!total && !row) return;
    if (!row) {
      row = document.createElement('div');
      row.className = 'amr-cod-submit-total';
      row.dir = 'ltr';
      row.setAttribute('aria-live', 'polite');
    }
    if (submit.parentElement !== form) submit.parentElement.classList.add('amr-cod-submit-stack');
    // Keep the app's calculated amount, but show the delivered total before confirmation.
    let totalLabel = row.querySelector('.amr-cod-submit-total-label');
    if (!totalLabel) {
      totalLabel = document.createElement('span');
      totalLabel.className = 'amr-cod-submit-total-label';
      totalLabel.lang = 'ar';
      totalLabel.dir = 'rtl';
      totalLabel.textContent = 'المجموع مع التوصيل';
      row.prepend(totalLabel);
    }
    if (submit.previousElementSibling !== row) submit.before(row);
    if (total) {
      row.querySelectorAll('.rsi-cod-form-submit-total-value').forEach(previous => {
        if (previous !== total) previous.remove();
      });
      row.appendChild(total);
    }
  }

  function enhance() {
    queued = false;
    const embed = document.getElementById('_rsi-cod-form-embed');
    const form = embed?.querySelector('#_rsi-cod-form-modal-form');
    if (!form) return;
    embed.classList.add('amr-cod-design');
    const info = embed.closest('.product__info-container');
    syncProductPrice(info, form);
    const host = embed.parentElement;
    if (host.parentElement === info) host.classList.add('amr-cod-host');

    // Keep the native cart button below the COD card without moving either form or its controls.
    const cart = host.nextElementSibling;
    if (info && cart?.querySelector('product-form .product-form__submit')) {
      cart.classList.add('amr-cod-cart');
      if (!cart.querySelector(':scope > .amr-cod-cart-title')) {
        const basketTitle = document.createElement('h2');
        basketTitle.className = 'amr-cod-cart-title';
        basketTitle.lang = 'ar';
        basketTitle.dir = 'rtl';
        basketTitle.textContent = 'بغيتي تزيد عطور أخرى؟';
        cart.prepend(basketTitle);
      }
      let trust = form.querySelector(':scope > .amr-cod-trust') || cart.querySelector('.amr-cod-trust');
      if (!trust) {
        trust = document.createElement('div');
        trust.className = 'amr-cod-trust';
        trust.dir = 'rtl';
        ['الدفع عند الاستلام', 'توصيل 24 ساعة'].forEach(text => {
          const item = document.createElement('span');
          item.textContent = text;
          trust.appendChild(item);
        });
      }
      // Only the decorative reassurance text moves; purchase and cart handlers stay untouched.
      if (trust.parentElement !== form) form.appendChild(trust);
    }
    form.querySelectorAll('._rsi-build-block-custom-text').forEach(block => {
      if (block.textContent.trim() === 'Paiement \u00e0 la livraison') block.classList.add('amr-cod-original-heading');
    });
    const totalLabel = form.querySelector('[data-checkout-line="total"] ._rsi-modal-checkout-line-title');
    if (totalLabel && totalLabel.textContent !== 'Total \u00e0 payer') totalLabel.textContent = 'Total \u00e0 payer';
    form.querySelectorAll('input:not([type="hidden"])').forEach(input => {
      styleIcon(input);
      const label = input.parentElement.querySelector('label');
      if (label && input.id && !label.htmlFor) label.htmlFor = input.id;
    });
    const submit = form.querySelector('._rsi-modal-submit-button');
    if (submit) {
      // Releasit uses inline !important declarations for these visual properties.
      const styles = { background: '#249b5b', 'border-radius': '8px', 'box-shadow': 'none', 'font-size': '19px' };
      Object.entries(styles).forEach(([key, value]) => {
        if (submit.style.getPropertyValue(key) !== value) submit.style.setProperty(key, value, 'important');
      });
      const label = submit.querySelector(':scope > span');
      if (label) {
        Array.from(label.childNodes).forEach(node => {
          if (node.nodeType === Node.TEXT_NODE && /COMMANDEZ|COMMANDER|اطلب/.test(node.textContent) && node.textContent !== 'COMMANDEZ - اطلب الآن ') {
            node.textContent = 'COMMANDEZ - اطلب الآن ';
          }
        });
      }
      positionSubmitTotal(form, submit);
    }
  }

  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(enhance);
  }
  function init() {
    const scope = document.querySelector('product-info') || document.querySelector('main');
    if (!scope) return;
    new MutationObserver(schedule).observe(scope, { childList: true, subtree: true, characterData: true });
    window.addEventListener('load', schedule, { once: true });
    document.addEventListener('shopify:section:load', schedule);
    enhance();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();


